export const GET_KENZER_ROOTS_INTEGRATION = 'GET_KENZER_ROOTS_INTEGRATION'
export const GENERATE_KENZER_ROOTS_KEY = 'GENERATE_KENZER_ROOTS_KEY'
export const SAVE_KENZER_ROOTS_CONFIG = 'SAVE_KENZER_ROOTS_CONFIG'
export const DISCONNECT_KENZER_ROOTS = 'DISCONNECT_KENZER_ROOTS'
export const LAUNCH_KENZER_ROOTS_SSO = 'LAUNCH_KENZER_ROOTS_SSO'
